import React from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown} from "react-bootstrap";
import Phone from "../.././../images/phone.svg"
import "./OfficeDetailsBanner.scss";
import { CONTACT_PAGE_URL } from "@Components/common/site/constants";
import {
    VALUATION_PAGE_URL
  } from "@Components/common/site/constants";
import AskusaQuestion from "@Components/AskusaQuestion/AskusaQuestion";
export const uknumberformat = (x) => {
    if (!x) return x; 
    const currentValue = x.toString().replace(/[^\d]/g, '');
    return `${currentValue.slice(0, 5)} ${currentValue.slice(5, 11)}`; 
}
const OfficeDetailsBanner = (props) => {
    return (
        <React.Fragment>
           <section className="office-details-banner">
               <Container>
                   <Row>
                       <Col lg={9}>
                        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                          <div className="back-button-wrap"><Link className="back-link" to={CONTACT_PAGE_URL?.alias}><span className="arrow-left-button d-none d-xl-block"><i className="arrow-banner-left"></i></span></Link><h1>{props.data?.Office_Name} Estate Agents</h1>
                          <div className="call"><a href={'tel:'+props.data?.Sales_Phone}> <img src={Phone}/> <span>Sales</span> {uknumberformat(props.data?.Sales_Phone)}</a></div> <div className="call"><a href={'tel:'+props.data?.Lettings_Phone}> <img src={Phone}/> <span>Lettings</span> {uknumberformat(props.data?.Lettings_Phone)}</a></div>
                          </div> 
                          <p className="address">{props.data?.Office_Address}</p>
                          </ScrollAnimation>
                       </Col>
                       <Col lg={3}>
                       <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                           <div className="button-groups-property-banner d-none d-lg-block">
                           <Link to={VALUATION_PAGE_URL.alias} className="btn btn-primary">Book a Valuation</Link>
                           <AskusaQuestion />
                           </div>
                           </ScrollAnimation>   
                       </Col>
                   </Row>
                   
               </Container>
           </section>
        </React.Fragment>
    )
}

export default OfficeDetailsBanner;